module.exports = __webpack_public_path__ + "static/media/groupImg.da5567a5.png";